export default {
  title: 'OPS',
  route: {
    login: 'Login'
  },
  common: {
    tips: '提示',
    add: '新增',
    save: '保存',
    delete: '删除',
    entryTips: '请输入',
    chooseTips: '请选择',
    edit: '编辑',
    search: '查询',
    check: '查看',
    success: '操作成功',
    confirm: '确定',
    cancel: '取消',
    detail: '详情',
    close: '关闭',
    deleteTips: '确定要删除吗？',
    handle: '操作',
    all: '所有',
    time: '时间',
    to: '至',
    download: '下载',
    upload: '上传',
    fail: '操作失败',
    loading: '加载中',
    none: '无',
    noData: '暂无数据',
    selectTips: '请选中一条数据',
    menuMissing: '页面不存在',
    more: '更多',
    submit: '提交',
    year: '年',
    month: '月',
    type: '类型',
    agree: '同意',
    disagree: '不同意'
  },
  component: {
    back: '返回',
    exportStart: '准备导出',
    exporting: '导出中',
    exportSuccess: '导出成功',
    exportFail: '导出失败',
    sourceGroupInput: '输入数据源名称查询',
    sourceGroupOther: '其他数据源',
    sourceGroupDefault: '默认数据源'
  },
  login: {
    login: 'Login',
    username: '用户名',
    password: '密码',
    send: '发送',
    reSend: '重新发送',
    waitSecond: '秒后重新发送',
    verificationSend: '验证码已发送',
    verificationCode: '请输入验证码',
    usernameTips: '请输入用户名',
    passwordTips: '请输入密码',
    success: '登录成功，跳转中……'
  },
  view: {
    config: '配置数据图形',
    table: {
      name: '名字',
      type: '类型'
    },
    dataConfigView: '配置数据图形',
    selectChart: '选择图表类型',
    selectDataSource: '选择数据源',
    chartArea: '面积图',
    chartLine: '折线图',
    chartHistogram: '柱状图',
    chartPie: '饼图',
    tableTable: '表格',
    nameTips: '请输入图表名称',
    run: '运行',
    save: '保存',
    sConfig: '系列',
    xConfig: 'X轴配置项',
    yConfig: 'Y轴配置项',
    labelConfig: 'label配置项',
    column: '列',
    addYfield: '增加Y字段',
    addSeries: '增加系列',
    closeSeries: '关闭系列',
    addLabel: '增加Label',
    addColumn: '增加列',
    title: '视图配置',
    noData: '暂无数据',
    dataSourceError: '数据源有误',
    drawFail: '数据格式有误，绘图失败',
    rowAlert: '所选数据的长度不一致',
    nameAlert: '表格头部名称不得为空',
    repeatAlert: '表格头部名称不得重复'
  },
  header: {
    changeUserinfo: '修改个人信息',
    logout: '退出',
    changePassword: '修改密码',
    userName: '用户名',
    name: '姓名',
    password: '密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    phoneNum: '联系电话',
    email: '邮箱',
    group: '部门',
    realNameAlert: '请输入姓名',
    oldPasswordAlert: '请输入旧密码',
    newPasswordAlert: '请输入新密码',
    confirmPasswordAlert: '请再次输入密码',
    phoneNumAlert: '请输入联系电话',
    phoneCorrect: '手机号必须为数字值',
    emailAlert: '请输入邮箱',
    emailCorrect: '请输入正确的邮箱地址',
    passSameAlert: '两次输入密码不一致',
    checkPwd: '请输入8-20个字符(须包含大写字母、小写字母、数字、符号四种元素)'
  },
  serverMonitor: {
    appearAlarm: '产生告警',
    collectTarget: '采集指标',
    unit: '个',
    handle: '批量处理',
    serverMonitor: '服务监控',
    currentAlarm: '当前告警',
    appStatus: '应用状态',
    appList: '应用列表',
    hostIP: '主机IP',
    hostPerformance: '主机性能',
    performance: '性能指标',
    alarmCode: '告警编码',
    alarmName: '告警名称',
    locationInfo: '定位信息',
    alarmObject: '告警对象',
    alarmAddress: '告警地址',
    alarmType: '告警类型',
    alarmLevel: '告警等级',
    alarmTime: '告警时间',
    selectTips: '请至少选择一项',
    today: '今天',
    yesterday: '昨天',
    thirtyMins: '30分钟',
    oneHour: '1小时',
    threeHours: '3小时',
    sixHours: '6小时',
    twelveHours: '12小时',
    table: {
      alarmType: '告警类型',
      alarmObject: '告警对象',
      alarmLevel: '告警等级',
      alarmAddress: '告警地址',
      alarmContent: '告警描述',
      alarmTime: '开始时间',
      continueTime: '持续时长',
      processTime: '处理时间',
      charity: '责任人',
      alarmQueryOperate: '操作',
      serverDetailOperate: '操作',
      alarmCode: '告警编码',
      locationInfo: '定位信息',
      alarmName: '告警名称'
    }
  },
  dataDictionary: {
    add: '新增',
    addTo: '添加',
    search: '查询',
    addDic: '新增数据字典',
    amendDic: '编辑数据字典',
    addTable: '新增表',
    amendTable: '修改表',
    noData: '暂无数据',
    databaseType: '仓库类型',
    databaseName: '数据库名称',
    save: '保存',
    name: '名称',
    next: '下一步',
    back: '上一步',
    desc: '描述',
    connect: '关联',
    connectDic: '关联数据字典',
    databaseAlert: '请选择数据库',
    connectTable: '关联数据字典-选择表',
    operate: '操作',
    tableName: '表名',
    success: '操作成功',
    delete: '删除',
    property: '属性',
    type: '值类型',
    nameAlert: '名称只能是数组字母和"-"、"_"的组合',
    enumeration: '外键、枚举值',
    require: '必填',
    onlyRead: '只读',
    only: '唯一',
    yes: '是',
    no: '否',
    editor: '编辑',
    addProperty: '新增属性',
    amendProperty: '编辑属性',
    confirmDelete: '确认要删除吗?',
    table: {
      name: 'DataBase',
      databaseType: '仓库类型',
      desc: '描述',
      operate: '操作'
    },
    connectTableHead: {
      tableName: '表名',
      tableDesc: '描述'
    },
    propertyTable: {
      property: '属性',
      propertyName: '名称',
      type: '值类型',
      enumeration: '外键、枚举值',
      require: '必填',
      only: '唯一',
      onlyRead: '只读'
    }
  },
  alarmTrend: {
    saasAlarm: 'SAAS业务告警',
    opsAlarm: 'OPS系统告警',
    rank: '排名',
    alarmName: '告警名称',
    alarmTrendChart: '告警走势图',
    group: '模块',
    count: '数量',
    trend: '趋势',
    realTime: '实时',
    lastDay: '最近一天',
    lastWeek: '最近一周',
    to: '至',
    confirm: '确定',
    noData: '暂无数据',
    basicAlarm: '基础告警',
    appOnlineStatus: 'App Online Status',
    host: '站点',
    age: '时长',
    time: '问题发生时间',
    description: '问题'
  },
  networkTopology: {
    fit: '适应画布',
    success: '操作成功',
    edit: '编辑',
    node: '节点',
    group: '组',
    lineWidth: '线宽',
    color: '颜色',
    name: '名称',
    size: '尺寸',
    width: '宽度',
    height: '高度',
    length: '长度',
    save: '保存',
    update: '更新',
    link: '链接',
    page: '画布',
    grid: '网格对齐',
    choose: '选择',
    component: '组件',
    textInput: '文字输入',
    element: '元素',
    multiSelect: '多选',
    navigator: '导航器',
    addGroup: '成组',
    unGroup: '解组',
    delete: '删除',
    title: '全网拓扑',
    confirm: '确定',
    customNode: '自定义元素',
    searchPlaceHolder: '输入元素名称搜索',
    setTopoLink: '设置拓扑链接',
    filterByName: '输入名字过滤',
    showTools: '工具栏'
  },
  workFlowRoleManage: {
    addRole: '添加角色',
    roleName: '角色名称',
    userName: '用户名',
    addUser: '添加用户'
  },
  workFlowTemplateManage: {
    addTemplate: '新增模板',
    templateTitle: '模板名称',
    addProperty: '添加属性',
    property: '属性',
    name: '名称',
    type: '值类型',
    value: '值',
    require: '必填',
    editProperty: '编辑属性',
    yes: '是',
    no: '否'
  },
  componentMonitor: {
    monitor: '监控',
    table: {
      logicType: '类型',
      enable: '是否采集',
      uploadTime: '采集频率',
      appName: '组件名称',
      ip: 'ip',
      operate: '操作'
    }
  },
  packageManage: {
    createPackage: '新建程序包',
    search: '查询',
    clone: '克隆',
    delete: '删除',
    edit: '编辑',
    success: '操作成功！',
    searchPackage: '搜索程序包名称',
    searchVersion: '搜索版本号',
    editPackage: '编辑程序包',
    packageName: '程序包名称',
    appName: '应用名称',
    group: '应用分组',
    os: '平台类型',
    desc: '说明',
    deployPath: '默认部署路径',
    confirmDelete: '确认删除吗？',
    confirm: '确定',
    cancle: '取消',
    check: '检查',
    example: '例子',
    path: '路径',
    createVersion: '新建版本',
    editVersion: '编辑版本',
    cloneVersion: '克隆版本',
    creator: '创建人',
    buildPath: '部署路径',
    packageManage: '程序包管理',
    packageConfig: '程序包配置',
    submitVersion: '提交版本',
    installPath: '安装路径',
    packagePath: '包上传路径',
    version: '版本',
    preVersion: '原版本',
    type: '版本类型',
    fileInfo: '文件管理',
    processInfo: '进程',
    installInfo: '安装',
    updateInfo: '升级',
    advanced: '高级',
    host: '运行属主',
    pid: '监控进程',
    port: '监听端口',
    portException: '检测到进程异常',
    processException: '检测到端口异常',
    startupScript: '启动脚本',
    stopScript: '停止脚本',
    checkScript: '部署前检查脚本',
    afterRollbackScript: '回退后执行脚本',
    rollbackScript: '回退脚本',
    afterInstallScript: '安装后执行',
    afterUpgradeScript: '升级后执行',
    preInstallScript: '安装前执行',
    preUpgradeScript: '升级前执行',
    uploadFile: '上传文件',
    setPath: '配置路径',
    result: '检查结果',
    usefulPath: '路径正常！',
    none: '无',
    deletePackage: '对应程序包下的版本也将删除，是否确定删除？',
    uclConfig: '配置中心',
    bindConfig: '绑定配置',
    app: '应用',
    configList: '配置列表',
    key: 'KEY',
    selectConfig: '选择配置',
    select: '请选择',
    env: '环境',
    uploadFail: '文件上传失败',
    site: '站点',
    distributeSite: '分发站点',
    table: {
      instanceName: '实例',
      packageName: '程序包名称',
      creator: '创建人',
      group: '所属组',
      createTime: '创建时间',
      newVersion: '最新版本',
      version: '版本号',
      type: '版本类型'
    },
    rules: {
      packageName: '请输入程序包名称',
      appName: '请输入应用名称',
      group: '请输入应用分组',
      os: '请选择平台类型',
      deployPath: '请输入默认部署路径',
      delete: '请选择至少一个目标！',
      edit: '请选择一个目标',
      version: '请输入版本号',
      site: '站点不得为空',
      distributeSite: '分发站点不得为空',
      type: '请选择版本类型！',
      path: '请输入正确路径！',
      size: '上传文件大小超过200M'
    }
  },
  uclConfig: {
    search: '查询',
    group: '应用分组',
    app: '应用名称',
    version: '版本',
    multiDownload: '批量下载',
    multiUpload: '批量上传',
    createConfig: '新建配置项',
    none: '无',
    create: '新建',
    env: '环境',
    uclConfig: '配置托管中心',
    edit: '修改',
    delete: '删除',
    save: '保存',
    cancle: '取消',
    success: '操作成功！',
    configuration: '环境配置',
    key: 'KEY',
    value: 'VALUE',
    custom: '自定义',
    confirmDelete: '确定要删除？',
    fail: '操作失败！',
    editConfig: '编辑配置文件',
    upload: '上传',
    check: '浏览',
    file: '文件',
    machineList: '实例列表',
    machine: '机器',
    status: '状态',
    loading: '等待上传',
    uploadSuccess: '上传成功！',
    clone: '克隆配置',
    originVersion: '原始版本',
    targetVersion: '目标版本',
    path: '路径',
    inputPath: '请输入路径(非必填)',
    versionEmpty: '查询版本不得为空',
    table: {
      version: '版本',
      appName: 'APP',
      key: 'KEY',
      content: '配置内容',
      machineList: '实例列表',
      modifyTime: '修改时间',
      uclConfigOperate: '操作',
      name: 'CODE',
      desc: '说明',
      createTime: '创建时间',
      updateTime: '修改时间',
      operation: '操作',
      edit: '修改',
      getContent: '点击获取',
      path: '路径'
    },
    rules: {
      name: '请输入CODE',
      desc: '请输入说明',
      version: '请输入版本',
      envId: '请输入所填项',
      upload: '上传类型必须为config',
      repeat: '上传文件列表存在相同文件',
      uploadFail: '上传失败,上传文件已经存在',
      clone: '应用名称/原始版本/目标版本不得为空'
    }
  },
  siteList: {
    table: {
      address: '站点地址',
      bandWidth: '网络宽带',
      contact: '联系人',
      id: 'id',
      siteType: '站点',
      ipAddrSegment: 'IP地址段',
      name: '站点名称',
      siteCode: '站点编码',
      network: '网络运营商',
      operator: '操作者',
      phone: '联系电话',
      remarks: '备注',
      siteListOperate: '操作',
      accessId: 'accessKeyId',
      secretKey: 'secretKey',
      ec2endpoint: 'ec2EndPoint'
    }
  },
  hostList: {
    hostList: '主机列表',
    table: {
      id: 'id',
      hostName: '主机名称',
      nicType: '网卡类型',
      hostType: '主机类型',
      environment: '环境',
      ip1: 'ip1',
      ip2: 'ip2',
      siteCode: '所属站点',
      group: '所属项目组',
      department: '所属项目组',
      applications: '运行服务',
      status: '主机状态',
      createTime: '创建时间',
      system: '系统',
      systemVersion: '系统版本',
      contact: '联系人',
      phone: '联系电话',
      operator: '操作者',
      remarks: '备注',
      instanceType: '实例类型',
      availabilityZone: '可用区',
      amiID: 'AMI ID',
      virtualization: '虚拟系统',
      instanceId: '实例ID',
      securityGroups: '安全组',
      architecture: '主机架构',
      publicIpAddresses: '公网IP地址',
      privateIpAddresses: '内网IP地址',
      diskSpace: '磁盘大小'
    },
    ipFuzzyQuery: '主机ip模糊查询',
    export: '导出',
    search: '查询',
    add: '新增',
    save: '保存',
    startSync: '开始同步',
    detail: '详细',
    update: '修改',
    delete: '删除',
    tag: '标记',
    deleteBatch: '批量删除',
    deleteConfirm: '确定要删除吗？',
    changeSelectAlert: '请选择操作对象',
    monitor: '监控',
    success: '操作成功',
    fail: '操作失败',
    awsSync: '与AWS同步',
    basic: '基础信息',
    platform: '平台信息',
    remark: '备注',
    softwares: '软件信息',
    operator: '运营商',
    nics: '网卡信息',
    empty: '暂无'
  },
  clusterManager: {
    addCluster: '新建集群',
    editCluster: '编辑集群',
    deleteCluster: '删除集群',
    clusterName: '集群名称',
    tester: '测试负责人',
    operator: '运维负责人',
    choose: '选择',
    remarks: '备注',
    open: '展开',
    hide: '隐藏',
    envType: '环境类型',
    hostList: '主机列表',
    choosen: '已选择',
    host: '主机',
    table: {
      host: '主机IP',
      hostName: '主机名',
      status: '运行状态',
      agentState: 'Agent状态',
      clusterName: '集群名称',
      createTime: '创建时间',
      creator: '创建人',
      envType: '集群环境',
      operator: '运维负责人',
      remarks: '备注',
      tester: '测试负责人'
    }
  },
  ABNodeConfig: {
    search: '查询',
    ip: 'IP地址',
    port: '端口',
    group: '组',
    app: '应用',
    nodeCreate: '节点添加',
    nodeRelease: '节点发布',
    confirmDelete: '确认删除吗?',
    desc: '描述',
    save: '保存',
    success: '操作成功',
    table: {
      ipaddress: 'IP地址',
      servPort: '端口',
      groupName: '组',
      serviceName: '应用',
      descs: '描述',
      releaseTime: '发布时间'
    }
  },
  ABUserConfig: {
    search: '查询',
    key: '键值',
    user: '用户',
    desc: '描述',
    switch: '全量切换',
    rollBack: '全量回滚',
    userCreate: '添加用户',
    userRelease: '发布',
    save: '保存',
    success: '操作成功',
    confirmDelete: '确认删除吗?',
    download: '下载模板',
    upload: '导入用户',
    uploadRule: '上传类型必须为excel',
    table: {
      userKey: '键值',
      userName: '用户',
      descs: '描述',
      releaseTime: '发布时间'
    }
  },
  instanceManage: {
    instanceManage: '实例管理',
    appGroup: '所属分组',
    appName: '应用名称',
    programPackage: '程序包',
    cluster: '集群',
    releaseOverview: '发布概览',
    killProcess: '强制中断',
    rePublish: '重新发布',
    operations: '运维',
    develop: '研发',
    test: '测试',
    machineUnit: '台',
    packageUnit: '个程序包',
    host: '主机',
    resource: '资源',
    version: '版本',
    deployStrategy: '部署策略',
    installWay: '安装方式',
    deployPath: '部署路径',
    scriptPath: '脚本路径',
    status: '状态',
    table: {
      siteCode: '站点',
      id: 'id',
      host: 'ip',
      group: '所属分组',
      appName: '应用名称',
      packageName: '包名',
      version: '版本',
      developer: '开发责任人',
      tester: '测试责任人',
      operations: '运维责任人',
      createTime: '创建时间',
      status: '状态',
      count: '实例'
    }
  },
  instanceList: {
    instanceList: '实例列表',
    search: '查询',
    version: '版本',
    ip: 'ip',
    start: '启动',
    stop: '停止',
    restart: '重启',
    success: '操作成功！',
    fail: '操作失败！',
    tipStart: '实例已经启动，不能再启动',
    tipStop: '实例已经停止，不能再停止',
    tips: '提示',
    tipUninstall: '确定要卸载吗？',
    tipDowngrade: '将会回退到上一个版本',
    tipDowngrade2: '没有上一个版本，不能回退',
    table: {
      id: 'id',
      ip: 'ip',
      group: '所属分组',
      appName: '应用名称',
      packageName: '包名',
      preVersion: '上一个版本',
      version: '版本',
      createTime: '创建时间',
      status: '进程状态',
      desc: '备注'
    }
  },
  envauthority: {
    group: '部门',
    user: '用户',
    groupTips: '请输入部门',
    nameTips: '请输入用户名',
    operator: '操作人',
    operate: '操作',
    addCurrentPage: '添加当前页',
    addResource: '添加仓库',
    selectTips: '请选中一条数据',
    addHost: '添加机器',
    department: '分组',
    userName: '用户名',
    departmentAlert: '请选择部门',
    byIp: '按IP查询',
    save: '保存',
    deleteConfirm: '确认删除吗？',
    database: '数据库名称',
    authAlert: '请至少选择一项权限',
    clearAll: '全部清空',
    success: '操作成功',
    onlyRead: '只读',
    onlyWrite: '只写',
    authority: '权限',
    addTo: '添加',
    addAuthority: '新增权限',
    editAuthority: '修改权限',
    machine: '机器',
    repertory: '仓库',
    resource: '资源管理',
    table: {
      group: '部门',
      name: '用户',
      type: '类型',
      operator: '操作人',
      updateTime: '操作时间',
      operate: '操作'
    },
    hostTable: {
      group: '分组',
      hostName: '主机名',
      ip1: '主机IP',
      status: '运行状态',
      operate: '操作'
    }
  },
  ITDeviceMonitor: {
    flow: '流量',
    today: '今天',
    yesterday: '昨天',
    site: '站点',
    devType: '设备类型',
    devIP: '设备IP',
    search: '查询',
    currentAlarm: '当前告警',
    ipTips: '请选择设备IP',
    performance: '性能指标',
    time: '时间',
    split: '至',
    timeAlert: '开始时间必须小于结束时间',
    ipAlert: 'IP不得为空',
    title: 'IT设备监控',
    cpuSize: '内存大小',
    cpuUsed: '使用内存',
    cpuRate: '内存使用率',
    outletFlow: '输出流量',
    inletFlow: '输入流量',
    table: {
      alarmObject: '告警对象',
      alarmLevel: '告警等级',
      alarmContent: '告警描述',
      alarmTime: '开始时间',
      continueTime: '持续时长',
      charity: '处理责任人',
      processAdvise: '处理建议'
    }
  },
  userTrend: {
    yesterdayOnline: '昨日在线用户数',
    todayOnline: '今日在线用户数',
    onlineUser: '在线用户数',
    offlineUser: '掉线用户数',
    all: '总计',
    setting: '设置',
    variation: '波动值',
    deviation: '偏差',
    mustInt: '必须是数值',
    deviationTips: '0-1的小数',
    auto: '自动'
  },
  dataConfig: {
    addDataSource: '新增数据源',
    name: '数据源名称',
    type: '数据源类型',
    sourceTips: '默认数据源不可配置'
  },
  dicManage: {
    group: '组',
    code: '编码',
    name: '名称',
    desc: '描述',
    addDic: '新增字典',
    editDic: '编辑字典',
    table: {
      group: '组',
      code: '编码',
      name: '名称',
      desc: '描述'
    }
  },
  agentManage: {
    online: '在线',
    offline: '离线',
    none: '无',
    group: '所属组',
    status: '状态',
    agentStatus: 'Agent状态',
    create: '添加',
    agentConfig: 'Agent配置',
    isOpen: '已启用',
    isNotOpen: '未启用',
    app: '应用',
    appName: '应用名称',
    logPath: '日志路径',
    logFile: '日志文件',
    uploadFreq: '采集频率(分钟)',
    monitorInterval: '监控周期(天)',
    serverPath: '安装路径',
    appList: '应用列表',
    logCollect: '日志采集目录',
    siteCode: '站点',
    clone: '克隆',
    oriIP: '源IP',
    targetIP: '目标IP',
    targetIPTips: '请选择目标IP',
    table: {
      group: '所属组',
      ip: 'IP',
      status: 'Agent状态',
      version: 'Agent版本'
    }
  },
  examinationReport: {
    type: '类型',
    alarmType: '分类',
    alarmCount: '告警数',
    systemExamination: '系统体检报告',
    changeExamination: '变更体检报告',
    before20min: '变更前20分钟',
    after20min: '变更后20分钟',
    after40min: '变更后40分钟',
    after60min: '变更后60分钟',
    alarmStatistics: '告警统计',
    changeDetail: '变更单',
    updateTime: '上线时间',
    operator: '升级操作人',
    ip: '变更IP',
    content: '变更内容',
    rule: '邮件推送规则',
    table: {
      updateTime: '时间',
      checkCount: '体检项数',
      alarmCount: '告警数',
      type: '类型'
    }
  },
  releaseStatistics: {
    allCount: '累计发布次数',
    failCount: '累计失败',
    successCount: '累计成功',
    success: '成功',
    fail: '失败',
    title: '版本统计',
    lastMonth: '最近一月',
    lastWeek: '最近一周'
  },
  logOperation: {
    userName: '操作账户',
    opModule: '操作模块',
    opType: '操作类型',
    opTime: '操作时间',
    table: {
      opTime: '操作时间',
      userName: '操作账户',
      opModule: '操作模块',
      opType: '操作类型',
      detail: '详细信息'
    }
  },
  countAlarm: {
    common: '一般',
    critical: '严重',
    fatal: '致命',
    prompt: '提示'
  },
  releaseVersion: {
    type: '版本类型',
    group: '业务模块',
    version: '系统版本号',
    releaseTime: '发布时间',
    charity: '升级负责人',
    note: '备注',
    relaseStatus: '版本升级状态',
    remainProblem: '遗留问题',
    export: '导出',
    table: {
      version: '系统版本号',
      type: '版本类型',
      group: '业务模块',
      releaseTime: '发布时间',
      createTime: '录入时间',
      creater: '录入人',
      charity: '升级负责人',
      note: '备注'
    }
  },
  roleManage: {
    usable: '启用',
    unusable: '禁用',
    name: '角色名称',
    yes: '是',
    description: '角色描述',
    enabled: '是否启用',
    addRole: '新增角色',
    editRole: '编辑角色',
    menuList: '分配菜单',
    allSelect: '全选',
    table: {
      name: '角色名称',
      description: '描述',
      creator: '创建人',
      createTime: '创建时间',
      enabled: '状态'
    }
  },
  menuManage: {
    detail: '详细信息',
    menuName: '菜单名称',
    buttonName: '按钮名称',
    desc: '描述',
    code: '编码',
    sort: '排序',
    interface: '接口地址',
    menuButton: '菜单按钮',
    parentMenu: '父菜单',
    belongMenu: '所属菜单',
    inPage: '是否在菜单中',
    interfaceName: '接口名称',
    topMenu: '顶级菜单',
    yes: '是',
    no: '否',
    menu: '菜单',
    editMenu: '编辑菜单',
    addMenu: '新增菜单',
    editButton: '编辑按钮',
    addButton: '新增按钮'
  },
  accidentEntry: {
    group: '问题模块',
    reason: '问题根因',
    status: '状态',
    title: '标题',
    startTime: '发生时间',
    findTime: '发现时间',
    endTime: '恢复时间',
    createTime: '录入时间',
    effect: '影响范围',
    effectLevel: '影响级别',
    problemSource: '问题来源',
    detail: '事故描述',
    reasonAnalysis: '根因分析',
    solution: '解决方案',
    correctAction: '改进措施',
    entryUser: '录入人',
    historyRecord: '历史记录',
    amend: '修改了',
    make: '将',
    from: '从',
    change: '变更为',
    export: '导出',
    table: {
      title: '标题',
      status: '状态',
      effectLevel: '影响级别',
      detail: '事故描述',
      startTime: '发生时间',
      duration: '恢复时长',
      effect: '影响范围',
      reason: '问题根因',
      group: '问题模块'
    }
  },
  ITDevice: {
    siteName: '站点名称',
    siteCode: '站点编码',
    devType: '设备类型',
    devIp: '设备IP',
    monitor: '监控',
    export: '导出',
    cabinetCode: '机柜编号',
    snmpAccount: 'SNMP账号',
    authProtocol: 'auth协议',
    authPassword: 'auto密码',
    privProtocol: 'priv协议',
    privPassword: 'priv密码',
    name: '设备名称',
    ip: '设备IP',
    contact: '联系人',
    phone: '联系电话',
    remarks: '备注',
    addDevice: '新增设备',
    editDevice: '编辑设备',
    table: {
      siteName: '站点名称',
      cabinetCode: '机柜编号',
      devType: '设备类型',
      name: '设备名称',
      ip: '设备IP'
    }
  },
  dial: {
    name: '任务名称',
    desc: '任务描述',
    frequency: '拨测周期',
    available: '可用率',
    availability: '可用率低于',
    duration: '持续时间',
    trigDelay: '时延大于',
    delay: '时延',
    minutes: '分钟',
    _1minutes: '1分钟',
    _5minutes: '5分钟',
    _15minutes: '15分钟',
    _30minutes: '130分钟',
    userName: '用户名',
    password: '密码',
    running: '运行中',
    stopping: '暂停中',
    run: '运行',
    stop: '暂停',
    addTask: '新建任务',
    addTerminalTask: '新建终端登录',
    objectTips: '输入格式有误，请输入正确的json格式',
    mustInt: '必须是数值',
    time: '时间',
    result: '结果',
    test: '测试',
    success: '成功',
    fail: '失败',
    hide: '隐藏',
    show: '显示',
    step: '步骤',
    url: 'url地址',
    table: {
      name: '任务名称',
      desc: '任务描述',
      status: '状态',
      resAvailability: '可用率',
      type: '拨测类型',
      delay: '延迟',
      currentTime: '最近一次调用时间'
    },
    detailTable: {
      time: '时间',
      name: '任务名称',
      result: '结果',
      delay: '时延',
      detail: '详细内容'
    }
  },
  dataSearch: {
    searchHistory: '查询历史',
    dataSearchHistory: '数据查询历史',
    operateUser: '操作用户',
    dataSearchDetail: '数据查询详情',
    addSearchConfig: '新增查询配置',
    editSearchConfig: '编辑查询配置',
    dataName: '数据名称',
    dataNameTips: '请输入数据名称',
    databaseAlert: '请选择数据库',
    tableAlert: '请选择表',
    instanceAlert: '请选择实例',
    dataSource: '数据源',
    rule: '排序规则',
    reverse: '倒叙',
    choose: '选择',
    viewConfig: '界面配置',
    time: '时间',
    chooseDataBase: '选择数据库',
    chooseTable: '选择表',
    chooseInstance: '选择实例',
    next: '下一步',
    back: '上一步',
    property: '属性',
    name: '名称',
    databaseType: '数据库类型',
    isShow: '是否显示',
    isSearch: '是否查询',
    isVague: '是否模糊',
    yes: '是',
    table: {
      userName: '操作用户',
      databaseType: '数据库类型',
      database: '数据库',
      dataTable: '数据表',
      condition: '查询条件',
      time: '操作时间'
    },
    databaseTable: {
      name: 'DataBase',
      databaseType: '数据库类型',
      desc: '描述'
    },
    dataTable: {
      tableName: '表名',
      tableDesc: '描述'
    },
    instanceTable: {
      instanceId: '实例ID',
      desc: '描述'
    }
  },
  appDelivery: {
    addDelivery: '新建部署任务',
    appName: '应用名称',
    appGroup: '应用分组',
    programPackage: '程序包',
    cluster: '集群',
    releaseOverview: '发布概览',
    killProcess: '强制中断',
    rePublish: '重新发布',
    releaseConfirm: '发布确认',
    operations: '运维',
    develop: '研发',
    publish: '发布',
    confirmTips1: '本次发布涉及',
    confirmTips2: '个站点',
    confirmTips3: '本次发布将创建',
    confirmTips4: '个任务',
    test: '测试',
    machineUnit: '台',
    packageUnit: '个程序包',
    selectTips: '请选中一条数据',
    host: '主机',
    resource: '资源',
    version: '版本',
    deployStrategy: '部署策略',
    installWay: '安装方式',
    deployPath: '部署路径',
    scriptPath: '脚本路径',
    status: '状态',
    checkCenter: '检查中心',
    confirmConfig: '请确认如下配置项再发布:',
    upgradeOption: '升级选项',
    beforeUpgrade: '升级前停止',
    afterUpgrade: '升级后启动',
    installOption: '安装选项',
    afterInstall: '安装后启动',
    releaseOption: '发布选项',
    afterRelease: '发布后检查',
    logs: '过程日志',
    logOutOfTime: '获取日志超时',
    logDetail: '详细日志',
    anomalyDetection: '异常诊断',
    same: '与目标文件一致',
    diff: '与目标文件不同',
    noneFile: '目标文件不存在',
    table: {
      group: '所属组',
      appName: '应用名称',
      version: '版本',
      clusterName: '部署集群',
      envType: '部署环境',
      creator: '创建人',
      createTime: '创建时间',
      status: '状态',
      // 程序包表头
      appPackage: '程序包名称',
      instanceName: '实例',
      // 概览表头
      host: '主机IP',
      packageName: '程序包名称',
      deployPath: '部署路径',
      oriVersion: '原版本',
      targetVersion: '目标版本',
      schedule: '部署进度'
    },
    diffTable: {
      key: 'Key',
      dir: '路径',
      result: '检查结果'
    }
  },
  platform: {
    addPlatform: '新建工具',
    editPlatform: '编辑工具',
    checkHistory: '查看历史任务',
    toolName: '工具名称',
    fileName: '文件名',
    type: '类别',
    fileFormat: '文件格式',
    machines: '目标机器',
    scriptType: '后置脚本',
    open: '展开',
    hide: '隐藏',
    hostList: '主机列表',
    choosen: '已选择',
    explain: '说明',
    execute: '执行',
    executeTime: '执行时间',
    executeResult: '执行结果',
    check: '查看',
    codeDetail: '命令详情',
    connectTips: '代码内容不得为空',
    historyTask: '历史任务',
    table: {
      type: '类别',
      ip: 'IP',
      toolName: '工具名称',
      startTime: '开始时间',
      endTime: '结束时间',
      operator: '操作人',
      operate: '操作'
    }
  },
  hostMapping: {
    totalCount: '总量',
    check: '查看',
    machinCount: '机器',
    powerOn: '开机',
    powerOff: '关机',
    noData: '暂无数据',
    generatorRoom: '站点',
    siteCode: '站点编码',
    network: '网络运营商',
    total: '总数',
    instanceType: '机器类型',
    department: '模块',
    moduleName: '模块名称',
    module: '模块',
    applications: '部署应用',
    machine: '机器',
    machineType: '机器型号',
    hostIP: '主机IP',
    none: '无',
    baseInfo: '基本信息',
    hostPerformance: '主机性能',
    today: '今天',
    yesterday: '昨天',
    thirtyMins: '30分钟',
    oneHour: '1小时',
    threeHours: '3小时',
    sixHours: '6小时',
    twelveHours: '12小时',
    search: '查询',
    time: '时间',
    to: '至',
    startTime: '开始时间',
    endTime: '结束时间',
    timeAlert: '开始时间必须小于结束时间',
    ip: 'ip'
  },
  chart: {
    noData: '暂无数据',
    close: '关闭',
    config: '配置',
    on: '第',
    week: '周',
    problemCount: '问题总数',
    seriousCount: '严重数',
    releaseCount: '版本数',
    patchCount: '补丁数',
    prompt: '提示',
    common: '一般',
    critical: '严重',
    allCount: '总计：',
    fatal: '致命',
    threshold: '阈值',
    fullScreen: '全屏',
    exitScreen: '退出全屏'
  },
  alarmStrategy: {
    kpiMappingTitle: '指标配置',
    levelRepeat: '告警级别已经存在',
    rulesNoEmpty: '必须有告警规则',
    edit: '操作',
    alarmGroup: '告警组',
    strategyTitle: '告警策略',
    alarmRule: '告警规则',
    addRule: '新增告警规则',
    title: '告警策略',
    createStrategy: '新增策略',
    changeStrategy: '修改策略',
    alarmType: '告警类型',
    alarmName: '告警名称',
    alarmLevel: '告警级别',
    alarmCode: '告警编码',
    alarmIP: '告警IP',
    trigger: '触发条件',
    duration: '持续时间(分钟)',
    recovery: '恢复条件',
    enable: '是否启用',
    yes: '是',
    no: '否',
    advise: '处理建议',
    search: '查询',
    kpiMapping: '关联指标配置',
    charity: '责任人',
    noConfigData: '暂无配置数据',
    change: '修改',
    delete: '删除',
    deleteConfirm: '确定要删除吗？',
    success: '操作成功',
    fail: '操作失败',
    continue: '持续',
    remind: '请输入[xxx]>(50),多个条件可用 "&&" 或 "||" 拼接',
    minute: '分钟',
    deleteSelectAlert: '请选择删除对象',
    changeSelectAlert: '请选择修改对象',
    createSelectAlert: '请选择需要新增策略对象',
    addKpiAlarm: '新增指标告警',
    appGroup: '应用分组',
    appName: '应用名称',
    alarmKey: '告警Key',
    kpiKey: '告警指标',
    ip: '告警IP',
    triggerStyle: '触发类型',
    append: '添加',
    save: '保存',
    noEmpty: '必须有应用名称',
    userGroups: '告警组',
    addThirdAlarm: '新增第三方告警',
    selectAll: '全部',
    rule: '规则',
    value: '值',
    alarmCountType: '维度',
    add: '添加',
    kpiKeyNoEmpty: '告警指标不得为空',
    editAlarmStrategy: '修改告警查询',
    messageGroups: '短信告警组',
    mailGroups: '邮件告警组',
    to: '至',
    alarmMoment: '告警时间段(24小时制)',
    timeError: '告警时间段必须同时选择开始、结束时间',
    processPlan: '处理方案',
    processSteps: '处理流程',
    step: '步骤',
    cancel: '取消',
    alarmTag: '告警标记',
    alarmMapRule: '字段映射',
    alarmObject: '告警对象',
    alarmAddress: '告警地址',
    alarmContent: '告警描述',
    alarmTime: '告警时间',
    locationInfo: '定位信息',
    tagField: '告警字段',
    sourceField: '日志字段名',
    tagFieldType: '告警字段类型',
    kpiAlarm: '新增指标告警',
    thirdAlarm: '新增第三方告警',
    field: '告警字段',
    timingOn: '定时开启',
    rules: {
      value: '告警规则的值不得为空',
      triggerTime: '告警规则的持续时间不得为空',
      field: '告警规则的告警字段不得为空',
      stepName: '步骤名不得为空'
    },
    table: {
      alarmType: '告警类型',
      appName: '应用名称',
      alarmName: '告警名称',
      alarmLevel: '告警级别',
      alarmCode: '告警编码',
      kpiKey: '告警Key',
      enable: '是否启用',
      ip: 'ip',
      charity: '责任人',
      userGroups: '告警组',
      // trigger: '触发策略',
      // recovery: '恢复策略',
      alarmStrategyOperate: '操作',
      addStrategyOperate: '操作'
    }
  },
  alarmQuery: {
    table: {
      alarmType: '告警类型',
      siteCode: '站点',
      alarmObject: '告警对象',
      alarmLevel: '告警等级',
      alarmAddress: '告警地址',
      alarmContent: '告警描述',
      alarmTime: '开始时间',
      continueTime: '持续时长',
      processTime: '处理时间',
      charity: '责任人',
      alarmQueryOperate: '操作',
      serverDetailOperate: '操作',
      alarmCode: '告警编码',
      locationInfo: '定位信息',
      alarmName: '告警名称'
    },
    search: '查询',
    time: '时间',
    to: '至',
    startTime: '开始时间',
    endTime: '结束时间',
    alarmType: '告警类型',
    alarmLevel: '告警级别',
    export: '导出',
    handle: '人工处理',
    multiHandle: '批量处理',
    unSelected: '请选择处理的告警',
    handleResult: '处理结果',
    handleOpinion: '处理意见',
    submit: '提交',
    currentAlarm: '当前告警',
    historyAlarm: '历史告警',
    currentAlarmCount: '当前告警数',
    todayAlarmCount: '今日新增告警数',
    maxRetentionTime: '最大滞留时长',
    levelWorst: '致命',
    levelBad: '严重',
    levelNormal: '一般',
    server: '服务',
    tips: '提示',
    success: '操作成功',
    fail: '操作失败',
    changeSelectAlert: '请选择修改对象',
    timeAlert: '开始时间必须小于结束时间',
    alarmDesc: '告警描述',
    errorCode: '错误码',
    appName: '应用名称',
    num: '数量',
    top5Alarm: 'Top5警告',
    currentTime: '本次时间',
    lastTime: '上次时间',
    alarmName: '告警名称',
    trgType: '触发类型',
    alarmCode: '告警编码',
    alarmObject: '告警对象',
    alarmAddress: '告警地址',
    alarmContent: '告警描述',
    alarmTime: '开始时间',
    recoverTime: '恢复时间',
    continueTime: '持续时间',
    charity: '责任人',
    processPlan: '处理方案',
    locationInfo: '定位信息',
    advise: '处理结果',
    alarmDetail: '告警详情',
    processTime: '处理时间'
  },
  dashBoard: {
    push: '添加',
    showList: '显示列表',
    hideList: '隐藏列表',
    darkTheme: '护眼模式',
    refreshRate: '定时刷新',
    dashBoardDetail: '查看dashBoard',
    dashBoardEdit: '编辑dashBoard',
    dashBoardAdd: '新增dashBoard',
    name: '名称',
    _1minute: '1分钟',
    _5minutes: '5分钟',
    _10minutes: '10分钟',
    _30minutes: '30分钟',
    close: '关闭',
    saveTime: '保存时间',
    viewRepeatTips: '视图已存在',
    timeAlert: '开始时间必须小于结束时间',
    titleAlert: '请输入需要保存的名称',
    today: '今天',
    title: '请输入Dashboard名称',
    deleteConfirm: '确定要删除吗？',
    list: {
      desc: '名称',
      name: '名称',
      type: '类型'
    }
  },
  resourceModel: {
    inputSearch: '输入资源名称搜索',
    search: '查询',
    addResource: '新增资源模型',
    describe: '说明',
    resourceType: '资源类型',
    resourceName: '资源名称',
    flagId: '表名',
    save: '保存',
    nameAlert: '任务名称只能是英文、数字或者英文数字组合',
    createResourceModel: '新增资源模型',
    success: '操作成功！',
    fail: '操作失败！',
    addProperty: '添加属性',
    editProperty: '修改属性',
    edit: '编辑',
    deleteResource: '删除资源',
    resourceModel: '资源模型',
    property: '属性',
    type: '值类型',
    name: '名称',
    require: '必填',
    readOnly: '只读',
    only: '唯一',
    display: '是否显示',
    operation: '操作',
    value: '枚举值',
    confirmDelete: '是否确定删除？',
    delete: '删除',
    id: 'ID',
    encrypt: '加密',
    forbidOperation: '只读属性不可修改！',
    sysDic: '字典组',
    forSearch: '可查询',
    table: {
      search: '可查询',
      property: '属性',
      type: '值类型',
      name: '名称',
      require: '必填',
      readOnly: '只读',
      only: '唯一',
      display: '是否显示',
      value: '枚举值'
    }
  },
  repertory: {
    inputSearch: '输入资源名称搜索',
    inputIp: '输入IP搜索',
    search: '查询',
    createInstance: '新建实例',
    eidtInstance: '编辑实例',
    operation: '操作',
    resourceType: '资源类型',
    resourceName: '资源名称',
    save: '保存',
    success: '操作成功！',
    fail: '操作失败！',
    edit: '编辑',
    confirmDelete: '是否确定删除？',
    forbidOperation: '只读属性不可修改！',
    ip: 'IP',
    yes: '是',
    no: '否',
    e_search: '可查询',
    uri: 'url',
    createTime: '创建时间',
    table: {
      uri: 'url',
      fileName: '文件名称',
      updateTime: '修改时间',
      size: '文件大小'
    },
    to: '至'
  },
  logCountAnalysis: {
    title: '日志量分析',
    group: '所属分组',
    appName: '应用名称',
    IP: 'IP',
    search: '查询',
    time: '时间',
    split: '至',
    timeAlert: '开始时间必须小于结束时间',
    ipAlert: 'IP不得为空'
  },
  userDistribution: {
    stop: '停止刷新',
    start: '开始刷新',
    refreshRate: '刷新频率',
    userCount: '在线设备数',
    tmlCountryCount: '在线国家或地区数',
    userMax: '历史最大在线设备数',
    hisOnlineCountryMax: '历史最大在线国家或地区数',
    todayOnlineTmlMax: '今日最大在线设备数',
    todayLoginTmlCount: '今日活跃设备数'
  },
  systemQuality: {
    systemTitle: '系统运行质量',
    time: '时间',
    search: '查询',
    accidentCount: '系统事故统计',
    versionCount: '系统版本统计',
    split: '至',
    accident: '事故数',
    totalRecoveryTime: '累计恢复时长',
    avgRecoveryTime: '平均恢复时长',
    maxRecoveryTime: '最大恢复时长',
    accidentTrend: '事故趋势',
    accidentType: '事故分类',
    accidentModule: '系统事故模块分布',
    accidentReason: '系统事故根因分布',
    version: '版本数',
    regularVersionCount: '常规版本',
    patchVersionCount: '补丁版本',
    versionTrend: '版本发布趋势',
    versionType: '版本分类',
    accidentDiagram: '系统事故趋势图',
    accidentWeekCount: '系统事故统计图(周)',
    versionWeekCount: '系统版本统计图(周)',
    versionDiagram: '版本发布趋势图',
    module: '模块分布',
    reason: '根因分布',
    regularVersion: '常规版本按模块分布',
    patchVersion: '补丁版本按模块分布',
    timeAlert: '开始时间必须小于结束时间'
  },
  kpiMapping: {
    title: '指标配置',
    group: '所属分组',
    appName: '应用名称',
    siteCode: '站点',
    search: '查询',
    create: '新增',
    change: '修改',
    delete: '删除',
    deleteConfirm: '确定要删除吗？',
    kpiKey: '指标关键字',
    count: '字段',
    x: 'X字段',
    xType: 'X字段类型',
    y: 'Y字段',
    yType: 'Y字段类型',
    xDesc: 'X字段描述',
    yDesc: 'Y字段描述',
    type: '类型',
    add: '添加',
    chartType: '图表类型',
    chartUnit: '单位',
    isShow: '是否显示',
    status: '分类',
    kpiType: 'KPI类型',
    time: '时间',
    yes: '是',
    no: '否',
    isVisual: '是否显示',
    describe: '描述',
    redis: 'Redis请求数',
    createStrategy: '新增策略',
    changeAlert: '请选择修改对象',
    deleteAlert: '请选择删除对象',
    success: '操作成功',
    fail: '操作失败',
    appNameAlert: '应用名称不能为空',
    kpiKeyAlert: '指标关键字不能为空',
    remind: '请输入[xxx]>(50),多个条件可用"&&"或"||"拼接',
    clone: '克隆',
    cloneKpi: '克隆指标',
    cloneAlarm: '克隆告警',
    origin: '源',
    target: '目标',
    confirm: '确定',
    notEmpty: '所填项不得为空',
    fieldAlert: 'X字段、X字段描述、Y字段、Y字段描述、类型不得为空',
    table: {
      siteCode: '站点',
      group: '所属分组',
      appName: '应用名称',
      kpiKey: '指标关键字',
      desc: '描述'
    }
  },
  logAnalysis: {
    logSearch: '日志查询',
    offlineTask: '离线任务',
    group: '所属组',
    app: '应用',
    search: '查询',
    time: '时间',
    IP: 'IP',
    host: 'host',
    split: '至',
    jump: '跳转',
    downloadLocale: '下载本地',
    addDownload: '添加下载',
    downloadAlert: '请选择添加对象',
    downloadList: '下载列表（单次最多50个文件，大小不超过1GB)',
    downloadNumAlert: '文件数不得超出50个',
    downloadSizeAlert: '文件大小不得超出1GB',
    key: '路径',
    logSize: '大小(MB)',
    syncS3: '同步S3文件列表',
    downloadRepeatAlert: '任务已存在,不可重复添加',
    indexName: '索引名称',
    taskName: '任务名称',
    offlineExport: '离线导入ES',
    timeAlert: '开始时间必须小于结束时间',
    success: '操作成功',
    placeholderRemain: '输入小写字母，数字和“-”',
    indexNameAlert: '请输入正确的索引名称格式',
    fileName: '文件名称',
    fileSize: '文件大小',
    downloadStatus: '下载状态',
    importStatus: '导入状态',
    taskDetail: '任务详情',
    timeIntervalAlert: '搜索时间区间不得大于七天',
    syncIntervalAlert: '搜索时间区间不得大于七天',
    appNameAlert: '应用名称不得为空',
    operate: '操作',
    deleteConfirm: '确定要删除吗？',
    delete: '删除',
    doneAlert: '请等待任务完成',
    downloadCurrentPage: '下载当前页',
    clearTableList: '清空当前列表',
    username: '用户名',
    password: '密码',
    kibanaEdit: 'Kibana密码设置',
    kibanaButton: 'Kibana帐号',
    save: '保存',
    logStatistics: '日志统计',
    fileSizeTips: '文件大小(MB)',
    fileNum: '文件个数',
    byDay: '按天',
    byMonth: '按月',
    byYear: '按年',
    awsCount: 'AWS日志文件个数',
    localCount: '本地采集个数',
    awsSize: 'AWS采集大小',
    localSize: '本地文件大小',
    size: '大小',
    count: '个数',
    searchDateTips: '最多支持查询31天',
    searchMonthTips: '最多支持查询36个月',
    searchYearTips: '最多支持查询12年',
    table: {
      key: '路径',
      groupName: '所属组',
      appName: '应用',
      logTime: '时间',
      logSize: '大小(MB)',
      createTime: '创建时间',
      loginCustomerName: '创建人',
      taskName: '任务名称',
      indexName: '索引名称',
      status: '状态',
      totalSize: '文件大小(MB)',
      host: 'IP'
    }
  },
  appManager: {
    groupManager: '分组管理',
    createApp: '新建应用',
    statusManager: '状态维护',
    deleteConfirm: '确认删除吗？',
    appName: '应用名称',
    success: '操作成功',
    editApp: '编辑应用',
    editGroup: '编辑分组',
    createGroup: '新增分组',
    search: '查询',
    amend: '修改',
    delete: '删除',
    create: '新增',
    belongingGroup: '所属项目组',
    developer: '开发责任人',
    tester: '测试责任人',
    operations: '运维责任人',
    remark: '备注',
    save: '保存',
    running: '运行态',
    stopping: '维护态',
    expand: '展开',
    collapse: '折叠',
    groupStopAlert: '所属分组当前为维护态',
    table: {
      siteCode: '站点',
      appName: '应用名称',
      groupName: '所属项目组',
      developer: '开发责任人',
      name: 'GROUP',
      tester: '测试责任人',
      operations: '运维责任人',
      desc: '备注'
    }
  },
  alarmSubscribe: {
    name: '姓名',
    search: '查询',
    groupManage: '用户分组管理',
    addSubscribe: '新增告警用户',
    amendSubscribe: '修改告警用户',
    save: '保存',
    mail: '邮箱',
    phone: '电话',
    notifyMode: '通知方式',
    enable: '是否启用',
    yes: '是',
    no: '否',
    remarks: '备注',
    groups: '分组',
    alarmList: '告警列表',
    groupName: '分组名称',
    alarmType: '告警类型',
    deleteConfirm: '确定要删除吗？',
    delete: '删除',
    success: '操作成功',
    add: '添加',
    alarmLevelNotify: '通知规则',
    alarmLevel: '告警级别',
    addUserGroup: '新建用户组',
    addUserKindGroup: '新增用户分组',
    userGroupName: '用户组名',
    remark: '备注',
    addUser: '添加用户',
    exist: '用户名已存在',
    userList: '用户列表',
    table: {
      userName: '姓名',
      email: '邮箱',
      phone: '电话',
      notifyMode: '通知方式',
      enable: '是否启用',
      remarks: '备注',
      remark: '备注',
      groupName: '用户组名',
      createTime: '创建时间'
    }
  },
  loginLog: {
    userName: '用户名',
    loginTime: '登录时间',
    timeAlert: '开始时间必须小于结束时间',
    loginSuccess: '登录成功',
    loginFail: '登录失败',
    to: '至',
    search: '查询',
    table: {
      userName: '用户名',
      role: '角色',
      siteName: '访问点',
      status: '状态',
      ip: 'IP地址',
      browser: '浏览器',
      loginTime: '登录时间',
      logoutTime: '退出时间'
    }
  },
  securityRole: {
    name: '名称',
    search: '查询',
    create: '新增',
    add: '添加',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    addRole: '新增角色',
    success: '操作成功',
    confirmDelete: '确认删除吗?',
    addNewRole: '新增安全角色',
    noChoice: '请选择需要添加的用户',
    table: {
      name: '角色名称',
      description: '描述',
      creator: '添加人',
      createTime: '添加时间',
      enabled: '状态'
    }
  },
  userManage: {
    cancel: '取消',
    ops: 'OPS',
    saas: 'SAAS',
    beUse: '可用',
    stopUse: '禁用',
    userName: '用户名',
    realName: '姓名',
    group: '部门',
    search: '查询',
    passwordReg: '请输入正确的格式(8-20位数字、大小写字母、半角符号组合)',
    add: '新增',
    delete: '删除',
    save: '保存',
    success: '操作成功',
    deleteConfirm: '确认删除吗?',
    addUserInfo: '新增用户信息',
    amendUserInfo: '修改用户信息',
    password: '密码',
    confirmPassword: '确认密码',
    notSame: '两次输入的密码不一样',
    passwordAlert: '请输入密码',
    phoneNum: '联系电话',
    email: '邮箱',
    assignRole: '分配角色',
    roleName: '角色名称',
    assignedRole: '已分配角色',
    alreadyExist: '用户名已存在',
    pleaseInputPassword: '请输入密码',
    rePassword: '请再次输入密码',
    userNameTips: '请输入用户名',
    authorize: '授权',
    table: {
      userName: '用户名',
      source: '来源',
      realName: '姓名',
      roleList: '角色',
      phoneNum: '联系电话',
      email: '邮箱',
      enabled: '状态',
      createTime: '创建时间',
      creator: '创建人',
      userOperate: '操作',
      name: '角色名称',
      description: '描述'
    }
  },
  logComponentManage: {
    appServiceConfig: '动态级别配置',
    topicConfig: 'TOPIC配置',
    appLogPathConfig: '应用日志路径配置',
    appLogRouteConfig: '应用日志路由配置',
    zipkinManage: '分布式跟踪',
    kpiInterval: '指标采集配置',
    staticConfig: '静态级别配置',
    collectInterval: '采集间隔',
    groupName: '分组名称',
    batchAmend: '批量修改',
    beUse: '启用',
    stopUse: '停用',
    yes: '是',
    no: '否',
    app: 'APP名称',
    chooseGroup: '请选择分组',
    enable: '开关',
    choosePath: '请输入路径',
    group: '应用分组',
    applyName: '应用名称',
    search: '查询',
    add: '新增',
    change: '修改',
    save: '保存',
    path: '路径',
    reportLevel: '上报级别',
    printLevel: '打印级别',
    writePath: '请输入路径',
    amend: '修改',
    delete: '删除',
    deleteConfirm: '确定要删除吗？',
    success: '操作成功',
    fail: '操作失败',
    id: 'id',
    appName: '应用名称',
    belongGroup: '所属分组',
    mqType: '消息队列类型',
    brokerList: '主服务器地址',
    reserve: '备用服务器地址',
    key: 'key',
    topic: 'topic',
    mustKey: '请输入key',
    mustTopic: '请选择topic',
    mustGroup: '请选择应用分组',
    mustAppName: '请选择应用',
    config: '配置',
    topicCN: 'TOPIC名称',
    topicType: 'TOPIC类型',
    partitionNum: '分区数',
    serverType: '服务类型',
    introduce: '说明',
    update: '修改',
    ipSearch: 'IP',
    ip: '服务器IP',
    status: '服务状态',
    port: '服务器端口',
    registerTime: '注册时间',
    updateTime: '更新时间',
    log1Level: 'log1ROOT级别',
    logLevel: 'log2ROOT级别',
    serverStatue: '服务状态',
    uploadLevel: '上报日志级别',
    uploadSysStatusInterval: '主机性能日志上报周期',
    controllerResTime: 'controller接口调用时延门限',
    serviceResTime: 'service接口调用时延门限',
    daoResTime: 'dao接口调用时延门限',
    isOpen: '采集所有接口日志',
    uploadLog1: '上传log1日志',
    uploadControl: '是否上传日志',
    unSelected: '请选择需要删除的应用',
    s: '请输入整数(秒)',
    ms: '请输入整数(毫秒)',
    online: '在线',
    offline: '离线',
    frequency: '采集间隔',
    numberTips: '请输入整数',
    instanceConfig: '实例配置',
    site: '站点',
    table: {
      appName: '应用名称',
      appGroup: '应用分组',
      path: '路径',
      uploadLevel: '上报级别',
      outputLevel: '打印级别',
      enable: '开关',
      group: '应用分组',
      mqType: '消息队列类型',
      brokerList: '主服务器地址',
      reserve: '备用服务器地址',
      topic: 'TOPIC名称',
      topicType: 'TOPIC类型',
      partitionNum: '分区数',
      serverType: '服务类型',
      introduce: '说明',
      ip: '服务器IP',
      port: '服务端口',
      status: '服务状态',
      logLevel: 'log2ROOT级别',
      log1Level: 'log1ROOT级别',
      uploadLogLevel: '上报日志级别',
      registerDate: '注册时间',
      updateTime: '更新时间',
      version: '日志组件版本',
      appVersion: '应用版本',
      endReply: '响应时间',
      createTime: '操作时间'
    }
  },
  zabbixMonitor: {
    title: 'zabbix监控',
    success: '操作成功',
    errorTips: '数据有误，无法生成图表',
    edit: '编辑',
    refreshRate: '刷新频率',
    stop: '停止刷新',
    start: '开始刷新',
    alarmLevel: '告警等级',
    alarmCount: '告警数量',
    no: '暂无告警',
    tipsHead: '即将离开本站，确定要跳转到',
    tipsFoot: '吗？',
    tipsTitle: '跳转提示',
    fail: '操作失败',
    offLine: '离线状态',
    delay: '时延',
    problemHost: '主机',
    problemDesc: '问题',
    problemTime: '问题发生时间',
    problemKeep: '时长',
    problemTitle: '最近20个问题',
    updateTime: '已更新：',
    history: '返回',
    addHost: '添加站点',
    editHost: '修改站点',
    name: '名称',
    hostName: '站点名称',
    code: '编码',
    hostCode: '站点编码',
    username: '用户名',
    none: '无',
    deleteConfirm: '确认删除吗？',
    selectTips: '注：删除、修改操作前请选择操作对象',
    selectedItem: '当前选择：',
    selectAlert: '请选择操作对象',
    add: '新增',
    delete: '删除',
    password: '密码',
    to: '指向',
    url: '访问地址',
    save: '保存',
    test: '测试',
    noSite: '没有可以添加的站点',
    urlTips: '要带上协议如http',
    ping: 'ping'
  },
  queryworkOrder: {
    creator: '创建人',
    type: '类型',
    status: '状态',
    siteType: '站点',
    orderDetail: '新开机申请-工单详情',
    operator: '操作人',
    node: '节点名称',
    option: '审批意见',
    advise: '处理意见',
    record: '审批记录',
    hostInfo: '主机信息',
    ipTips: '请至少输入一个IP',
    export: '导出',
    table: {
      applicant: '申请人',
      templateId: '类型',
      status: '状态',
      site: '站点',
      startDate: '创建时间',
      endDate: '完成时间',
      currentNode: '当前环节',
      currentAssignee: '当前处理人'
    }
  },
  cloudApplication: {
    bootUpRequest: '新开机工单申请',
    paasInitRequest: 'PAAS初始化工单申请',
    serviceRequest: '业务上线工单申请',
    shutdownRequest: '关机工单申请',
    dbPermissionRequest: '主机与数据库权限申请',
    closePermissionRequest: '关闭权限申请',
    revokeRequest: '回收权限申请',
    choose: '选择',
    time: '申请日期',
    siteType: '站点',
    applicant: '申请人',
    department: '申请人部门',
    approver: '审批人',
    ccpeople: '抄送人员',
    expectedTime: '期望完成时间',
    remark: '备注',
    reason: '申请理由',
    models: '机型',
    num: '数量',
    disk: '磁盘',
    network: '网段',
    businessType: '业务类型',
    versionType: '版本类型',
    group: '模块',
    group2: '分组',
    app: '应用',
    version: '版本',
    operator: '操作人',
    option: '审批意见',
    currentAssignee: '当前处理人',
    versionNum: '版本号',
    releaseTime: '发布时间',
    revokedPeople: '被回收人',
    empowerment: '被赋权人',
    grantDepartment: '部门',
    users: '被处理人',
    revokedPeopleTips: '请选择被回收人',
    empowermentPeopleTips: '请选择被赋权人',
    newProcess: '新建流程',
    select: '选择',
    selectPerson: '选择用户',
    businessOnline: '业务上线申请',
    processTmlErr: '未识别的流程',
    businessOnlineReason: '业务上线-申请单',
    businessOnlineDetails: '业务上线申请',
    businessDetails: '业务上线申请-工单详情'
  },
  siteNavigation: {
    name: '站点名称',
    noDAta: '暂无数据'
  },
  navigationSetting: {
    name: '站点名称',
    location: 'URL',
    rewrite: 'Rewrite',
    host: 'HOST',
    defaultIndex: '默认',
    noDAta: '暂无数据'
  },
  orderStatistics: {
    year: '年',
    month: '月',
    week: '周',
    orderType: '类型',
    yearAlert: '请输入整数',
    monthAlert: '请输入1-12的整数',
    number: '第'
  },
  remoteConfig: {
    uploadConfig: '数据上传设置',
    siteName: '站点名称',
    siteCode: '站点编码',
    uploadAlarm: '是否上传告警',
    uploadKpi: '是否上传指标',
    uploadHostInfo: '是否上传主机信息',
    uploadFileSite: '文件上传站点',
    uploadPaas: 'PAAS层数据获取',
    yes: '是',
    no: '否'
  },
  grayConfig: {
    routeVersionName: '版本名称',
    routeRuleName: '路由规则',
    tagName: '灰度标签',
    routeStrategyName: '路由策略',
    routeVersionGroup: '组',
    tagStatus: '状态',
    createTime: '创建时间',
    releaseTime: '发布时间',
    operateTime: '操作时间',
    percent: '百分比',
    publish: '发布',
    rollback: '回滚',
    cut: '切换',
    end: '结束',
    download: '下载模板',
    uploadRule: '导入类型必须为excel',
    upload: '导入',
    export: '导出',
    routeKey: '键值',
    userName: '用户',
    infoDesc: '描述',
    clearData: '清空键值',
    importTips: '请先导入数据',
    table: {
      tagId: 'ID',
      routeVersionName: '版本名称',
      routeVersionGroup: '组',
      tagName: '灰度标签',
      routeRuleName: '路由规则',
      routeStrategyName: '路由策略',
      tagStatus: '状态',
      tagStatusAfter: '状态',
      tagCreateTime: '创建时间',
      releaseTime: '发布时间',
      modifyTime: '操作时间',
      operateType: '操作'
    }
  },
  grayMonitor: {
    application: '应用',
    releaseTime: '发布时间',
    group: '组',
    hisId: '发布历史ID',
    tag: '标签',
    version: '版本名称',
    table: {
      hisId: '发布历史ID',
      publishTime: '发布时间',
      replyApp: '应用',
      replyDate: '反馈时间',
      replyIp: '应用IP',
      routeRuleName: '路由规则',
      routeStrategyName: '路由策略',
      routeVersionGroup: '组',
      routeVersionName: '版本名称',
      tagId: 'ID',
      tagName: '灰度标签'
    }
  },
  activeUser: {
    activeUser: '活跃用户',
    activeTml: '活跃设备'
  },
  ALBTargetGroupManager: {
    onlineTitle: '已经存在目标组的IP',
    offlineTitle: '离线实例',
    freeTitle: '未添加到目标组的IP',
    relateGroup: '关联目标组',
    updateToGroup: '更新到目标组',
    deleteFromGroup: '从目标组中删除',
    selectTips: '请至少选择一条数据',
    onlineTable: {
      group: '模块',
      appName: '应用',
      tag: '目标组',
      status: '状态',
      port: '端口',
      instanceId: '实例ID'
    }
  },
  importantOperation: {
    opTime: '操作日期',
    group: '项目组',
    appName: '业务模块',
    level: '风险等级',
    batchDelete: '批量删除',
    duration: '操作时长',
    incidence: '业务影响',
    operator: '操作人',
    remarks: '备注',
    table: {
      group: '项目组',
      appName: '业务模块',
      opTime: '操作日期',
      duration: '操作时长',
      level: '风险等级',
      incidence: '业务影响',
      operator: '操作人',
      remarks: '备注'
    }
  },
  customExpiration: {
    group: '业务模块',
    name: '名称',
    type: '类型',
    operator: '维护人',
    updateTime: '更新时间',
    expireTime: '到期时间',
    remarks: '备注',
    batchDelete: '批量删除',
    table: {
      group: '业务模块',
      name: '名称',
      type: '类型',
      operator: '维护人',
      expireTime: '到期时间',
      updateTime: '更新时间',
      opTime: '修改时间',
      remarks: '备注'
    }
  },
  autoInspectionReport: {
    siteCode: '站点 ',
    inspectionTime: '巡检时间',
    system: '系统平台',
    resourceType: '资源分类',
    host: '主机地址',
    item: '指标项',
    resultType: '巡检结果',
    table: {
      time: '巡检时间',
      siteCode: '站点',
      system: '系统平台',
      resourceType: '资源分类',
      host: '主机地址',
      item: '指标项',
      result: '巡检结果',
      explain: '异常说明'
    }
  },
  autoInspectionConfig: {
    siteCode: '站点 ',
    system: '系统平台',
    resourceType: '资源分类',
    group: '主机群组',
    host: '主机地址',
    item: '指标项',
    rule: '巡检规则',
    ruleMethod: '检测方式',
    ruleValue: '值（0~100）%',
    ruleType: '规则分类',
    enabled: '是否启用',
    table: {
      siteCode: '站点',
      system: '系统平台',
      resourceType: '资源分类',
      host: '主机地址',
      item: '指标项',
      rule: '巡检规则',
      ruleType: '规则分类',
      enabled: '是否启用'
    }
  }
}
